import { render, staticRenderFns } from "./listDetail.vue?vue&type=template&id=3fa77eb9&scoped=true&"
import script from "./listDetail.vue?vue&type=script&lang=js&"
export * from "./listDetail.vue?vue&type=script&lang=js&"
import style0 from "./listDetail.vue?vue&type=style&index=0&id=3fa77eb9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa77eb9",
  null
  
)

export default component.exports